export default __webpack_public_path__ + "static/media/behavior.d37c651c.png";